module.exports = __webpack_public_path__ + "assets/check_circle-fill.4f84c625.svg";